export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/male_singer.f2f0c67.svg";